module.exports = __webpack_public_path__ + "img/wordle.83c2a71d.svg";